import { css, CSSObject } from "@emotion/react";

type Styles = {
  mobile?: CSSObject;
  tablet?: CSSObject;
  desktop?: CSSObject;
};

// Avoid applying a `max-width` so that we can allow a cascading effect to
// happen, e.g. tablet styles will apply if desktop styles are not provided.
export const mediaQueries = {
  mobile: `@media (min-width: 0)`,
  tablet: `@media (min-width: 660px)`,
  desktop: `@media (min-width: 1024px)`,
};

export const getResponsiveStyles = (styles: Styles) => {
  return [
    { [mediaQueries.mobile]: css(styles.mobile) || {} },
    { [mediaQueries.tablet]: css(styles.tablet) || {} },
    { [mediaQueries.desktop]: css(styles.desktop) || {} },
  ];
};
